import { render, staticRenderFns } from "./AdminShipperPriceNewModal.vue?vue&type=template&id=58ff1189"
import script from "./AdminShipperPriceNewModal.vue?vue&type=script&lang=js"
export * from "./AdminShipperPriceNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ff1189')) {
      api.createRecord('58ff1189', component.options)
    } else {
      api.reload('58ff1189', component.options)
    }
    module.hot.accept("./AdminShipperPriceNewModal.vue?vue&type=template&id=58ff1189", function () {
      api.rerender('58ff1189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminShipperPriceNewModal.vue"
export default component.exports